module.exports = __webpack_public_path__ + "static/media/avatar2.c700cc93.png";